module.exports = __webpack_public_path__ + "img/horizontal-dark.005a93e1.svg";